import React from "react";
import { cleanJoin } from "../../utils/stringUtil";
import "./UploadButton.scss";

function UploadButton({
  label = "",
  acceptDocumentTypes = "",
  onChange,
  className = "",
  inputName = "file",
}) {
  return (
    <div
      className={cleanJoin(
        "button",
        "is-inline-flex",
        "is-align-content-flex-end",
        "is-justify-content-flex-end",
        "p-0",
        "upload-button",
        className
      )}
    >
      <div className={cleanJoin("file", "is-small", "is-white")}>
        <label className={`p-4`}>
          <input
            accept={acceptDocumentTypes}
            className={`file-input is-clickable`}
            type="file"
            name={inputName}
            onChange={onChange}
          />
          <div className="file-label is-size-6 has-text-grey-darker">{label}</div>
        </label>
      </div>
    </div>
  );
}

export default UploadButton;
